import { FC, useState } from "react";

import Main from "../../components/layout/Main";
import MetaData from "../../components/MetaData";

import ProofStep from "./steps/ProofStep";

const SEO_TITLE = "Reiskosten vergoeden";

export type Step = FC<{ details: Details; setStep: (step: Step) => void }>;
export interface Details {
  actual_price: number;
  comment: string;
  iban: string;
  iban_name: string;
  proof_url: string;
  proof_content_type: string;
  sponsor_name: string;
  from: string;
  to: string;
  price: number;
  demonstrant_name: string;
}

const Show = (props: Details) => {
  const [Step, setStep] = useState<Step>(() => ProofStep);

  return (
    <Main>
      <MetaData title={SEO_TITLE} />
      <Step details={props} setStep={(newStep) => setStep(() => newStep)} />
    </Main>
  );
};

export default Show;
